import(/* webpackMode: "eager" */ "/opt/gzoo/repo/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/gzoo/repo/frontend/node_modules/@xyflow/react/dist/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutWrapper"] */ "/opt/gzoo/repo/frontend/src/components/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/gzoo/repo/frontend/src/components/Providers.tsx");
